import { consumerTagsService } from '@afterpaytouch/portal-api/consumer/tags'

export const {
  useGetConsumerTagsQuery,
  useGetConsumerTagsWithDataQuery,
  useCreateConsumerTagMutation,
  useUpdateConsumerTagMutation,
  endpoints: { getConsumerTags, getConsumerTagsWithData },
} = consumerTagsService
